// extracted by mini-css-extract-plugin
export default {"upcCodeWrapper":"UPCCodes_upcCodeWrapper__vSHeX"};